export enum LGEResultsStatusEnum {  
    noResults = "noResults",
    firstPreferences = "firstPreferences",
    declaration = "declaration",
    final = "final"
}